import gsap, { Power4 } from 'gsap'
import scroll from '../animations/scroll/locomotiveScroll'
import menu from '../menu'

export const defaultTransition = {
  name: 'default',

  enter({ next, current }) {
    current.container.style.display = 'none'

    return gsap.from(next.container, {
      opacity: 0,
      duration: 1.2
    })
  },

  leave({ current }) {
    if (menu.isOpen) {
      menu.menuLeave()
    }

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}